import React from 'react'
import MailingListSignup from '../../components/MailingListSignup/MailingListSignup'
import GreenProgressBar from '../../components/ProgressBars/GreenProgressBar/GreenProgressBar'
import "./ThankYouPage.css"

export default function ThankYouPage() {

  return (
    <div className='typ__container'>
      <div className='progress-bar__holder'>
        <GreenProgressBar progress="100" />
      </div>
      <div className='schedule__header-text'>
        <h1>Application Complete!</h1>
      </div>
      <div className='typ__top-text'>
        <h3>We look forward to our call to see if we're a good fit for
            working one-on-one to help you step authentically into your own success story by embracing your abilities!</h3>
      </div>
      <MailingListSignup />
    </div>
  )
}
